module.exports = __webpack_public_path__ + "img/btn.4f6b96f3.png";